<template>
  <Content>




      <section class="our-story-section py-4 py-md-5 px-3 px-md-4">
    <div class="container-fluid">
      <div class="story-card">
        <div class="row align-items-center g-4 g-lg-5">
          
          <!-- ستون متن و داستان -->
          <div class="col-12 col-lg-7">
            <div class="story-content" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
              
              <!-- تگ نشانگر کوچک بالا -->
              <div class="story-badge mb-3 d-inline-flex align-items-center gap-2">
                <i class="bi bi-book-half"></i>
                <span>{{ currentLang.subtitle }}</span>
              </div>

              <!-- تیتر بخش -->
              <h2 class="story-title mb-4">
                {{ currentLang.title }}
              </h2>

              <!-- پاراگراف اول: نسل جدید و تحول دیجیتال -->
              <p class="story-text mb-3">
                {{ currentLang.paragraph1 }}
              </p>

              <!-- پاراگراف دوم: کودکان ۴ تا ۱۴ سال و آموزش آنلاین -->
              <p class="story-text mb-4">
                {{ currentLang.paragraph2 }}
              </p>

              <!-- کارت‌های آمار و ویژگی‌های برجسته -->
              <div class="stats-grid row g-3 pt-2">
                <div class="col-6 col-sm-6">
                  <div class="stat-box d-flex align-items-center gap-3">
                    <div class="stat-icon icon-exp">
                      <i class="bi bi-award-fill"></i>
                    </div>
                    <div>
                      <span class="stat-number">{{ currentLang.expNumber }}</span>
                      <small class="stat-label d-block">{{ currentLang.expLabel }}</small>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-sm-6">
                  <div class="stat-box d-flex align-items-center gap-3">
                    <div class="stat-icon icon-age">
                      <i class="bi bi-emoji-smile-fill"></i>
                    </div>
                    <div>
                      <span class="stat-number">{{ currentLang.ageNumber }}</span>
                      <small class="stat-label d-block">{{ currentLang.ageLabel }}</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- ستون تصویر داستان -->
          <div class="col-12 col-lg-5">
            <div class="story-image-wrap text-center">
              <div class="image-frame position-relative">
                <img
                  src="/AboutWe1.png"
                  :alt="currentLang.title"
                  class="img-fluid story-img w-100 h-100"
                  loading="lazy"
                />
                
                <!-- المان دکوراتیو شیشه‌ای روی عکس -->
                <div class="decorative-pill d-flex align-items-center gap-2">
                  <i class="bi bi-rocket-takeoff-fill text-warning"></i>
                  <span>{{ currentLang.pillText }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>








 <section class="founder-section py-4 py-lg-5 px-3 px-md-4">
    <div class="container-fluid">
      
      <!-- تیتر اصلی بخش -->
      <div class="text-center mb-4 mb-lg-5" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
        <div class="section-badge d-inline-flex align-items-center gap-2 mb-2">
          <i class="bi bi-person-workspace"></i>
          <span>{{ currentLang.badge }}</span>
        </div>
        <h2 class="section-title">{{ currentLang.title }}</h2>
        <p class="section-desc text-muted">{{ currentLang.subtitle }}</p>
      </div>

      <div class="row g-4 align-items-start" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
        
        <!-- ستون اول: کارت پروفایل موسس -->
        <div class="col-12 col-lg-4">
          <div class="founder-card text-center p-4">
            
            <!-- تصویر موسس -->
            <div class="founder-img-wrap mx-auto mb-3">
              <img
                src="/MohammadKhaledFeyzi.png"
                :alt="currentLang.name"
                class="founder-img img-fluid"
                loading="lazy"
              />
              <div class="founder-verified" title="Certified & Award Winner">
                <i class="bi bi-patch-check-fill"></i>
              </div>
            </div>

            <!-- مشخصات -->
            <h3 class="founder-name mb-1">{{ currentLang.name }}</h3>
            <span class="founder-role d-block mb-3">{{ currentLang.role }}</span>
            <p class="founder-bio mb-4">{{ currentLang.bio }}</p>

            <!-- ویژگی‌های کلیدی فوری -->
            <div class="founder-quick-stats row g-2">
              <div class="col-6">
                <div class="q-stat">
                  <i class="bi bi-award text-primary"></i>
                  <strong>+۲۰ سال</strong>
                  <small>سابقه تدریس</small>
                </div>
              </div>
              <div class="col-6">
                <div class="q-stat">
                  <i class="bi bi-book text-success"></i>
                  <strong>+۱۰ عنوان</strong>
                  <small>کتاب و تالیف</small>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- ستون دوم: لیست دسته‌بندی‌شده دستاوردها و رزومه -->
        <div class="col-12 col-lg-8">
          <div class="row g-3">
            
            <div
              v-for="(item, index) in currentLang.achievements"
              :key="index"
              class="col-12 col-md-6"
            >
              <div class="achievement-card d-flex align-items-start gap-3 h-100 p-3">
                <div class="ach-icon-box" :class="item.category">
                  <i :class="item.icon"></i>
                </div>
                <div class="ach-info">
                  <span class="ach-tag d-inline-block mb-1">{{ item.tag }}</span>
                  <p class="ach-text mb-0">{{ item.text }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </section>







  <LearningFeatures></LearningFeatures>
  <OurTeamSlider></OurTeamSlider>
  <footerAdmin></footerAdmin>
   
  </Content>
</template>

<script setup>
import { computed } from "vue";

import Content from "@/components/AdminContent.vue";
import footerAdmin from "@/components/AdminFooter.vue";
import OurTeamSlider from "@/components/OurTeamSlider.vue";
import LearningFeatures from "@/components/LearningFeatures.vue";


import { lang } from "@/plugins/lang";

import enText from "@/locales/en/AboutWePage";
import faText from "@/locales/fa/AboutWePage";

const translations = {
  en: enText,
  fa: faText,
};

const currentLang = computed(() => translations[lang.value]);


</script>

<style scoped>
.story-card {
  background: linear-gradient(135deg, #ffffff 0%, #f6fcff 50%, #eef9ff 100%);
  border: 1px solid rgba(108, 206, 255, 0.25);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 12px 35px rgba(24, 50, 91, 0.07);
}

/* تگ نشانگر بالای تیتر */
.story-badge {
  background: rgba(108, 206, 255, 0.2);
  color: #0b69a3;
  font-weight: 700;
  font-size: 0.88rem;
  padding: 6px 14px;
  border-radius: 50px;
}

.story-badge i {
  color: #00cdc4;
}

/* تیتر بخش */
.story-title {
  font-size: 1.7rem;
  font-weight: 800;
  line-height: 1.7;
  color: #18325b;
}

/* پاراگراف‌ها */
.story-text {
  font-size: 1rem;
  line-height: 2;
  color: #4b5563;
  text-align: justify;
}

/* باکس‌های ویژگی/آمار */
.stat-box {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 12px 16px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.icon-exp {
  background: rgba(0, 205, 196, 0.15);
  color: #00a8a0;
}

.icon-age {
  background: rgba(255, 107, 129, 0.15);
  color: #ff4757;
}

.stat-number {
  font-size: 1.05rem;
  font-weight: 800;
  color: #18325b;
  display: block;
}

.stat-label {
  font-size: 0.78rem;
  color: #6b7280;
  font-weight: 600;
}

/* فریم عکس */
.image-frame {
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.1);
  background: #e2e8f0;
  aspect-ratio: 4 / 3;
}

.story-img {
  object-fit: cover;
  transition: transform 0.4s ease;
}

.image-frame:hover .story-img {
  transform: scale(1.03);
}

/* پیل دکوراتیو روی عکس */
.decorative-pill {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  padding: 8px 14px;
  border-radius: 30px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #18325b;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

[dir="ltr"] .decorative-pill {
  right: auto;
  left: 16px;
}

/* مدیا کوئری‌ها */
@media (max-width: 991.98px) {
  .story-card {
    padding: 24px;
  }

  .story-title {
    font-size: 1.45rem;
  }
}

@media (max-width: 575.98px) {
  .story-card {
    padding: 18px;
    border-radius: 18px;
  }

  .story-title {
    font-size: 1.25rem;
  }

  .story-text {
    font-size: 0.93rem;
  }

  .stat-box {
    padding: 10px 12px;
  }

  .stat-number {
    font-size: 0.95rem;
  }

}



/* section 2  */




/* بخش هدر سکشن */
.section-badge {
  background: rgba(0, 205, 196, 0.15);
  color: #008f89;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 6px 14px;
  border-radius: 50px;
}

.section-title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #18325b;
}

.section-desc {
  font-size: 0.95rem;
}

/* کارت پروفایل سمت چپ/راست */
.founder-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 20px;
}

.founder-img-wrap {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  position: relative;
  padding: 4px;
  background: linear-gradient(135deg, #00cdc4, #6cceff);
}

.founder-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #ffffff;
}

.founder-verified {
  position: absolute;
  bottom: 4px;
  right: 8px;
  color: #00cdc4;
  background: #ffffff;
  border-radius: 50%;
  font-size: 1.4rem;
  line-height: 1;
}

.founder-name {
  font-size: 1.3rem;
  font-weight: 800;
  color: #18325b;
}

.founder-role {
  font-size: 0.85rem;
  color: #00a8a0;
  font-weight: 700;
}

.founder-bio {
  font-size: 0.88rem;
  line-height: 1.8;
  color: #64748b;
}

.founder-quick-stats .q-stat {
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  padding: 10px 8px;
}

.q-stat i {
  font-size: 1.2rem;
  display: block;
  margin-bottom: 2px;
}

.q-stat strong {
  font-size: 0.95rem;
  color: #18325b;
  display: block;
}

.q-stat small {
  font-size: 0.72rem;
  color: #64748b;
}

/* کارت‌های افتخارات */
.achievement-card {
  background: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.achievement-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.07);
  border-color: #6cceff;
}

.ach-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}

/* تم‌های رنگی آیکون‌ها بر اساس نوع افتخار */
.cat-gold {
  background: #fff8e6;
  color: #d97706;
}

.cat-blue {
  background: #eff6ff;
  color: #2563eb;
}

.cat-purple {
  background: #f5f3ff;
  color: #7c3aed;
}

.cat-green {
  background: #ecfdf5;
  color: #059669;
}

.cat-cyan {
  background: #ecfeff;
  color: #0891b2;
}

.ach-tag {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
}

.ach-text {
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.7;
  color: #334155;
}

/* ریسپانسیو */
@media (max-width: 991.98px) {
  .founder-card {
    position: static;
    margin-bottom: 10px;
  }
}

@media (max-width: 575.98px) {
  .section-title {
    font-size: 1.35rem;
  }
  
  .achievement-card {
    padding: 12px;
  }

  .ach-text {
    font-size: 0.82rem;
  }
}


</style>




































































 

